import { render, staticRenderFns } from "./SelfServe.vue?vue&type=template&id=27685ec6&scoped=true&"
import script from "./SelfServe.vue?vue&type=script&lang=js&"
export * from "./SelfServe.vue?vue&type=script&lang=js&"
import style0 from "./SelfServe.vue?vue&type=style&index=0&id=27685ec6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27685ec6",
  null
  
)

export default component.exports